<template>
    <div>
        <button :aria-label="filterName" @click="toggle" :class="filter_elements.length>0?'selected':''">
            <span v-if="type=='complex'">{{filterName}}</span>
            <span v-else>{{filter_elements.length>0?items.find(item => item.id==filter_elements[0].id).value:filterName}}</span>
            <span class="filter_icon">
                <i v-if="!active" class="fas fa-angle-down"></i>
                <i v-else class="fas fa-angle-up"></i>
            </span>
        </button>
        <div v-if="active" v-click-outside="toggle">
            <div class="options_filters_container">
                <div v-if="type=='complex'" class="options_head">
                    <div class="input_search">
                        <label>
                            <div>
                                <input :aria-label="'Buscar '+filterName" :placeholder="'Buscar '+filterName" type="text" v-model="filter_key" @keyup="filterItems()">
                            </div>
                        </label>
                    </div>
                    <span class="icon_search">
                        <span>
                            <i class="fa fa-search"></i>
                        </span>
                    </span>
                </div>
                <div class="options_body">
                    <div class="contain">
                        <div v-if="!items.length">
                            <load-spiner></load-spiner>
                        </div>
                        <div v-else class="options_item">
                            <div v-if="filter_items_list.length>0||filter_key" class="item">
                                <li v-for="item in filter_items_list" @click="setFilter(item)" :class="filter_elements.includes(item)?'check':''">
                                    <span>
                                        {{item.value}}
                                    </span>
                                    <div class="checkmark">
                                    </div>
                                </li>
                            </div>
                            <div v-else class="item">
                                <li v-for="item in items" @click="setFilter(item)" :class="filter_elements.includes(item)?'check':''">
                                    <span>
                                        {{item.value}}
                                    </span>
                                    <div class="checkmark">
                                    </div>
                                </li>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="filter_elements.length>0" class="options_footer" @click="deleteFilter()">
                    <button class="restart_button">
                        Restablecer
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import vClickOutside from 'v-click-outside';
    Vue.use(vClickOutside);

    export default {
        props: ['filterName','type'],
        data() {
            return {
                items: [],
                filter_elements: [],
                filter_key: "",
                filter_items_list: [],
                active: false,
            }
        },
        mounted() {
            this.getItems();
        },
        methods: {
            filterItems: function() {
                this.filter_items_list = this.items.filter(item => item.value.toUpperCase().includes(this.filter_key.toUpperCase()));
            },
            getItems: function () {
                axios.post('/get/filter-items', {
                    filter: this.filterName,
                }).then(response => {
                    this.items = response.data;
                }).catch(e => {
                    console.log(e);
                });
            },
            toggle: function () {
                this.$root.$emit('toggleFilterProducts' , this, this.active);
            },
            setFilter: function (item) {
                var index = this.filter_elements.indexOf(item);

                if (this.type == 'complex') {
                    if (index < 0) {
                        this.filter_elements.push(item);
                    } else {
                        this.filter_elements.splice(index, 1);
                    }
                } else {
                    if (index < 0) {
                        this.filter_elements = [item];
                    } else {
                        this.filter_elements = [];
                    }
                }

                this.$root.$emit('loadFilterProducts' , this.filterName, this.filter_elements);
            },
            deleteFilter: function () {
                this.filter_elements = [];
                this.$root.$emit('loadFilterProducts' , this.filterName, this.filter_elements);
            }
        }
    }
</script>
